export default __webpack_public_path__ + "assets/4beacbf314a6cb4d0077e8ecd3c72a75.svg";